import React, { useContext, useMemo } from "react";
import { Drawer, DrawerHeaderLeft } from "./Appbar";
import { Box, IconButton, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { GlobalContext } from "../../GlobalContext";
import GroupsIcon from "@mui/icons-material/Groups";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PunchClockIcon from "@mui/icons-material/PunchClock";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Settings } from "./Settings";
import DescriptionIcon from "@mui/icons-material/Description";
import AllInboxIcon from "@mui/icons-material/AllInbox";

const Left = () => {
	const { t } = useTranslation('navigation');
	const navigate = useNavigate();
	const location = useLocation();

	const { openLeft, handlerSideLeft } = useContext(GlobalContext);

	const privileges = useMemo(() => {
		try {
			return JSON.parse(sessionStorage.getItem("privileges")) || {};
		} catch (error) {
			console.error("Error parsing privileges from sessionStorage:", error);
			return {};
		}
	}, []);

	const menuItems = [
		{
			show: privileges?.employees?.show_page,
			path: "/employees",
			selected: location.pathname === "/" || location.pathname === "/employees",
			label: t("employees.title"),
			icon: <GroupsIcon />,
		},
		{
			show: privileges?.schedule?.show_page,
			path: "/schedule",
			selected: location.pathname === "/schedule",
			label: t("schedule.title"),
			icon: <CalendarMonthIcon />,
		},
		{
			show: privileges?.timecard?.show_page,
			path: "/timecard",
			selected: location.pathname === "/timecard",
			label: t("timecard.title"),
			icon: <PunchClockIcon />,
		},
		{
			show: privileges?.overtime?.show_page,
			path: "/overtime",
			selected: location.pathname === "/overtime",
			label: t("overtime.title"),
			icon: <MoreTimeIcon />,
		},
		{
			show: privileges?.reports?.show_page,
			path: "/reports",
			selected: location.pathname === "/reports",
			label: t("reports.title"),
			icon: <DescriptionIcon />,
		},
		{
			show: privileges?.requests?.show_page,
			path: "/requests",
			selected: location.pathname === "/requests",
			label: t("request.title"),
			icon: <AllInboxIcon />,
		},
	];

	return (
		<Drawer variant="permanent" open={openLeft}>
			<DrawerHeaderLeft
				sx={{
					px: 1.5,
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					gap: 1,
				}}
			>
				<Box
					sx={{
						flex: 1,
						height: 44,
						display: "flex",
						alignItems: "center",
						overflow: "hidden",
					}}
				>
					{openLeft && (
						<Box
							component="img"
							src={JSON.parse(sessionStorage.getItem("images"))?.logo}
							alt="logo-app"
							sx={{
								width: "100%",
								height: "100%",
								objectFit: "contain",
								objectPosition: "left center",
							}}
						/>
					)}
				</Box>

				{openLeft && (
					<IconButton
						onClick={() => handlerSideLeft(!openLeft)}
						sx={{
							bgcolor: "primary.dark",
							"&:hover": { bgcolor: "primary.dark" },
							borderRadius: 2,
						}}
					>
						<ChevronLeftIcon sx={{ color: "#fff" }} />
					</IconButton>
				)}
			</DrawerHeaderLeft>

			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					height: "100%",
					justifyContent: "space-between",
					overflow: "hidden",
				}}
			>
				<List sx={{ pt: 1 }}>
					{menuItems
						.filter((item) => item.show)
						.map((item) => (
							<ListItemButton
								key={item.path}
								selected={item.selected}
								onClick={() => navigate(item.path)}
								sx={{
									px: openLeft ? 2.5 : 0,
									mx: openLeft ? 1 : "auto",
									mb: 0.5,
									minHeight: 44,
									width: openLeft ? "auto" : 48,
									borderRadius: 4,
									justifyContent: "center",
									alignItems: "center",

									"& .MuiListItemIcon-root": {
										minWidth: openLeft ? 40 : 0,
										mr: openLeft ? 1.5 : 0,
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
									},
								}}
							>
								<ListItemIcon>{item.icon}</ListItemIcon>
								{openLeft && <ListItemText primary={item.label} />}
							</ListItemButton>
						))}
				</List>

				<Box
					sx={{
						width: "100%",
						mt: 2,
					}}
				>
					<Settings openLeft={openLeft} />
				</Box>
			</Box>
		</Drawer>
	);
};

export { Left };
